import css from '@styled-system/css'
import React from 'react'
import { IconFacebook } from './icons/IconFacebook'
import { IconLinkedIn } from './icons/IconLinkedIn'
import { IconTwitter } from './icons/IconTwitter'
import Box from '../primitives/Box'

const styles = css({
  ':hover': {
    color: 'podcastBlue',
  },
})

export function SocialShare({ text }: { text: string }) {
  const url =
    typeof window === 'undefined'
      ? ''
      : window.location?.origin + window.location?.pathname
  const shareUrl = encodeURIComponent(url)
  const shareText = encodeURIComponent(text + ' ')

  return (
    <Box display="flex" gap={16} alignItems="center">
      <Box.a
        href={`https://twitter.com/intent/tweet/?text=${shareText}${shareUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on Twitter"
        css={styles}
      >
        <IconTwitter />
      </Box.a>

      <Box.a
        href={`https://facebook.com/sharer/sharer.php?u=${shareUrl}"`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on Facebook"
        css={styles}
      >
        <IconFacebook />
      </Box.a>

      <Box.a
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Share on LinkedIn"
        css={styles}
      >
        <IconLinkedIn />
      </Box.a>
    </Box>
  )
}
